import React, { Component } from "react";
import { SortAdornment } from "../../../../shared/SortAdornment/SortAdornment";
import { ORDER_TYPES } from "../../../../consts/api";
class IVPackageSales extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData"));

    this.state = {
      globalLang: languageData.global,
      reportData: props.reportData ? props.reportData : [],
      languageData: languageData.business_insights,
      sortBy: null,
      sortOrder: null,
    };

    window.onscroll = () => {
      return false;
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let returnState = {};

    if (
      nextProps.reportData !== undefined &&
      nextProps.reportData !== prevState.reportData
    ) {
      returnState.reportData = nextProps.reportData;
    }

    return returnState;
  }

  onSort = (field) => {
    const newSortDir =
      this.state.sortBy === field && this.state.sortDir === ORDER_TYPES.asc
        ? ORDER_TYPES.desc
        : ORDER_TYPES.asc;
    this.setState({ sortBy: field, sortDir: newSortDir });
    this.props.handleSort(field, newSortDir);
  };

  renderSortWrap = (field, label) => (
    <SortAdornment
      value={this.state.sortBy === field ? this.state.sortDir : undefined}
      onToggle={() => this.onSort(field)}
    >
      {label}
    </SortAdornment>
  );

  render() {
    return (
      <div className="table-responsive clients-table">
        <table className="table-updated setting-table table-min-width no-td-border no-hover">
          <thead className="table-updated-thead">
            {
              <tr>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "clinic",
                    this.state.reportData?.report_header?.clinic,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "package",
                    this.state.reportData?.report_header?.package,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "no_of_sales",
                    this.state.reportData?.report_header?.no_of_sales,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "total_sales_of_amount",
                    this.state.reportData?.report_header?.total_sales_of_amount,
                  )}
                </th>
                <th className="table-updated-th">
                  {this.renderSortWrap(
                    "balance_amount",
                    this.state.reportData?.report_header?.balance_amount,
                  )}
                </th>
              </tr>
            }
          </thead>
          <tbody className="ajax_body">
            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length > 0 &&
              this.state.reportData.report_data.map((obj, idx) => {
                return (
                  <tr key={idx} className="table-updated-tr">
                    <td className="table-updated-td">{obj.clinic}</td>
                    <td className="table-updated-td">{obj.package}</td>
                    <td className="table-updated-td">{obj.no_of_sales}</td>
                    <td className="table-updated-td">
                      {obj.total_sales_of_amount}
                    </td>
                    <td className="table-updated-td">{obj.balance_amount}</td>
                  </tr>
                );
              })}

            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length > 0 &&
              this.state.reportData.total && (
                <tr className="table-updated-tr">
                  <td className="table-updated-td bold">Total</td>
                  <td className="table-updated-td bold">
                    {this.state.reportData.total.unit_sold}
                  </td>
                  <td className="table-updated-td bold">
                    {this.state.reportData.total.gross_sales}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.taxable_amount}
                  </td>
                  <td className="table-updated-td">
                    {this.state.reportData.total.discount_percentage}
                  </td>
                </tr>
              )}

            {this.state.reportData &&
              this.state.reportData.report_data &&
              this.state.reportData.report_data.length === 0 && (
                <tr className="table-updated-tr">
                  <td
                    className="table-updated-td no-record no-float"
                    colSpan="10"
                  >
                    {this.state.languageData.bi_no_record_found}
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default IVPackageSales;
